import { ENVIRONMENT, Env } from '../constants/env';

type LoggerMethod = (...args: unknown[]) => void;
type Logger = LoggerMethod & {
  log: LoggerMethod;
  info: LoggerMethod;
  warn: LoggerMethod;
  error: LoggerMethod;
  debug: LoggerMethod;
};

const buildLogger = (): Logger => {
  const enabled = ENVIRONMENT === Env.DEV;

  const emit =
    (level: 'log' | 'info' | 'warn' | 'error' | 'debug'): LoggerMethod =>
    (...args) => {
      if (!enabled) return;
      const prefix = `[${level.toUpperCase()}]`;
      console[level](prefix, ...args);
    };

  const base = emit('log') as Logger;
  base.log = emit('log');
  base.info = emit('info');
  base.warn = emit('warn');
  base.error = emit('error');
  base.debug = emit('debug');
  return base;
};

export const logger = buildLogger();
